import { isMascotShape } from './morph-targets'
import type { MascotShape } from './morph-targets'

export const MASCOT_SHAPE_KEY = 'studio.aida.mascot-shape'

export function readMascotShape(): MascotShape {
  try {
    const value = window.localStorage.getItem(MASCOT_SHAPE_KEY)
    return isMascotShape(value) ? value : 'basis'
  } catch {
    return 'basis'
  }
}

export function writeMascotShape(shape: MascotShape) {
  try {
    window.localStorage.setItem(MASCOT_SHAPE_KEY, shape)
  } catch {
    // Private mode can reject writes.
  }
}
